import { isAlgoliaOn } from '../common/Utils';
import {
  getMainStoreInstance,
  aisStartEvent,
} from '../common/Algolia';
import searchBoxInit from './molecule/algolia-search-box';
import { hitsInit } from './molecule/algolia-hits';
import refinementListInit from './molecule/algolia-refinement-list';
import rangeSliderInit from './molecule/algolia-range-slider';
import { currentRefinedValuesInit } from './molecule/algolia-current-refined-values';
import sortByInit from './molecule/algolia-sort-by';

function instantSearchHeaderInit() {
  let result = false;

  if (isAlgoliaOn() === true) {
    if (getMainStoreInstance()) {
      searchBoxInit();
      result = true;
    }
  } else {
    console.log('Algolia is currently turned off in configuration.');
  }

  return result;
}

function instantSearchCoreInit() {
  let result = false;

  if (isAlgoliaOn() === true) {
    const store = getMainStoreInstance();

    if (store) {
      currentRefinedValuesInit();
      refinementListInit();
      rangeSliderInit();
      sortByInit();
      hitsInit();

      /* Trigger the first "render" event */
      $(document).trigger(aisStartEvent);

      result = true;
    }

    if ($('[data-js="signin"]').length) {
      $('#searchField').removeAttr('autocomplete');
    }
  } else {
    console.log('Algolia is currently turned off in configuration.');
  }

  return result;
}

// Named exports
export {
  instantSearchHeaderInit,
  instantSearchCoreInit,
};



// WEBPACK FOOTER //
// ./js/desktop/instantSearch.js